export const planningSteps = [
  { number: 1, title: "Capture", text: "Organize the important findings.", color: "bg-step-blue" },
  { number: 2, title: "Identify", text: "Turn findings into a clear problem list.", color: "bg-step-green" },
  { number: 3, title: "Define", text: "Establish the objectives you need to evaluate.", color: "bg-step-orange" },
  { number: 4, title: "Prioritize", text: "Determine what deserves attention first.", color: "bg-step-red" },
  { number: 5, title: "Map", text: "Organize constraints, movement considerations and dependencies.", color: "bg-step-purple" },
  { number: 6, title: "Sequence", text: "Build a logical treatment-planning roadmap.", color: "bg-step-teal" },
  { number: 7, title: "Review", text: "Stress-test the strategy before moving forward.", color: "bg-step-navy" },
];

export const understandings = [
  "You can understand the diagnosis.",
  "You can recognize the clinical problems.",
  "You can understand orthodontic mechanics.",
  "You can think about anchorage, movement and sequencing.",
];

export const caseChapters = ["Diagnosis", "Objectives", "Anchorage", "Biomechanics", "Movement", "Sequencing", "Reassessment", "Finishing"];

export const consistentOrder = [
  "First understand the case.",
  "Then identify the problems.",
  "Then define the objectives.",
  "Then establish priorities.",
  "Then identify constraints.",
  "Then map the movements that need to be considered.",
  "Then organize the sequence.",
  "Then review the strategy before moving forward.",
];
